"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styled_components_1 = __importDefault(require("styled-components"));
var Utility_1 = require("../Utility");
var StyledT2Icon = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  filter: none !important;\n  > svg {\n    height: 100%;\n    width: auto;\n  }\n"], ["\n  filter: none !important;\n  > svg {\n    height: 100%;\n    width: auto;\n  }\n"])));
var renderIcon = function (icon) {
    if (icon) {
        return react_1.default.createElement(StyledT2Icon, { className: "t2-icon" }, icon);
    }
    return null;
};
var Button = function (props) {
    var _a = (0, Utility_1.handleSize)((0, Utility_1.handleUtility)(props)), buttonRef = _a.buttonRef, children = _a.children, icon = _a.icon, iconRight = _a.iconRight, secondary = _a.secondary, danger = _a.danger, alert = _a.alert, ghost = _a.ghost, highlight = _a.highlight, round = _a.round, onClick = _a.onClick, className = _a.className, rest = __rest(_a, ["buttonRef", "children", "icon", "iconRight", "secondary", "danger", "alert", "ghost", "highlight", "round", "onClick", "className"]);
    var iconOnly = (icon || iconRight) && !children;
    var classes = (0, classnames_1.default)('t2-btn', className, {
        't2-secondary': secondary,
        't2-danger': danger,
        't2-alert': alert,
        't2-ghost': ghost,
        't2-highlight': highlight,
        't2-round': round,
        't2-icon-only': iconOnly,
    });
    var handleOnClick = props.disabled ? undefined : onClick;
    var content = (react_1.default.createElement(react_1.default.Fragment, null,
        renderIcon(icon),
        children ? react_1.default.createElement("span", { className: (0, classnames_1.default)({ 'icon-right': iconRight }) }, children) : null,
        renderIcon(iconRight)));
    return props.href ? (react_1.default.createElement("a", __assign({ role: 'navigation', ref: buttonRef, className: classes }, rest), content)) : (react_1.default.createElement("button", __assign({ role: 'button', ref: buttonRef, type: "button", className: classes, onClick: function (e) { return handleOnClick === null || handleOnClick === void 0 ? void 0 : handleOnClick(e); } }, rest), content));
};
exports.default = Button;
var templateObject_1;
